<template>
  <v-container fluid fill-height class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">

        <v-row :class="$vuetify.breakpoint.smAndDown?'section secone_square':'section secone'" align="center" justify="center">
          <v-card dark class="elevation-0 transparent">
            <v-row no-gutters>
              <v-col cols="12" class="pa-0 text-center">
                <p class="py-4">
                  <v-text-field
                    v-model="oid"
                    label="Номер платежа"
                    :prepend-inner-icon="this.check==true?'mdi-thumb-up-outline':this.check==false?'mdi-thumb-down-outline':''"
                    :append-icon="check==false?'mdi-reload':''"
                    @click:append="checkOrder()"
                    :value="this.orderId"
                    :loading="this.check==null"
                    outlined
                    flat
                    :error-messages="this.check==false?'Оплата еще не поступила':''"
                    :success-messages="this.check==true?'Оплата прошла успешно':''"
                  ></v-text-field>
                  <v-divider class="py-3"></v-divider>
                  <template v-if="check==true">
                    <p>Кнопка для скачивания будет доступна<br>в течении 48 часов с момента оплаты.</p>
                    <v-btn @click="download=!download" :loading="download" :disabled="download" dark color="green darken-3" :href="checkState.signedUrl">Скачать MosBas</v-btn>
                  </template>
                  <template v-if="check==false">
                    <p>
                    Мы получаем подтверждение платежа 3 раза:<br>
                    Сразу после оплаты, через 10 минут после оплаты и <br>
                    через 1 час. Если через час платеж не подтвержден, <br>
                    обратитесь к нам в чат или электронную почту.</p>
                  </template>
                  <template v-if="check==null">
                    <p>Дождитесь проверки платежа</p>
                  </template>
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
    data(){
        return {
          oid:null,
          check:null,
          download:false
        }
    },
    created(){
      this.oid=this.orderId
      this.checkOrder()
    },
    props:{
      'orderId': {
        type: String,
        require:true
      }
    },
    computed:{
      checkState(){
        return this.$store.getters.getCheck
      }
    },
    methods:{
      checkOrder(){
        this.check = null
        this.$store.dispatch('PAY_CHECK',this.oid).then(()=>{
          if(this.checkState.label==this.oid){
            this.check = true
          } else {
            this.check = false
          }
        }).catch(()=>{
          this.check = false
        })
      }
    }
    
}
</script>
<style scoped>
.section {
  min-height: 100vh;
}
.section.secone {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight1_30.jpg);
  background-size: cover;
}
.section.secone_square {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight1_square.jpg);
  background-size: cover;
}
</style>